import React, { useState, useEffect } from "react";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import SideBar from "../../components/sidebar";
import Header from "../../components/header";
import "../../assets/CSS/dashboard.css";
import "../../assets/CSS/forms.css";
import RangeTable from "../../components/rangeTable";
import API_BASE_URL from "../../config";
import "../../assets/CSS/loader.css";

function RangeEntry() {
  const navigate = useNavigate();
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loader, setLoader] = useState(false);
  const [reload, setReload] = useState(0);

  const handleSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    setIsSubmitting(true);

    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      setIsSubmitting(false);
      setLoader(false);
      return;
    }

    const formData = new FormData(formRef.current);

    try {
      const response = await fetch(API_BASE_URL + "/api/range-master", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert("Range added successfully");
        formRef.current.reset();
        setIsSubmitting(false);
        setLoader(false);
        setReload((prev) => prev + 1);
      } else {
        alert(result.error || "Error uploading data");
        setIsSubmitting(false);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
      setIsSubmitting(false);
      setLoader(false);
    }
  };

  return (
    <div>
      {loader && (
        <div className="loader">
          <div className="loader-spinner"></div>
        </div>
      )}
      <SideBar />
      <div className="main-content">
        <Header />
        <div id="form-content">
          <div id="form-header">
            <p>Range Master</p>
          </div>
          <hr />
          <form id="form" ref={formRef}>
            <div id="form-input">
              <label htmlFor="name">
                Range Name<span className="required">*</span>
              </label>
              <input
                type="text"
                name="name"
                id="name"
                placeholder="Enter Range Name"
                required
              />
            </div>
            <div id="form-input">
              <label htmlFor="address">Address</label>
              <input
                type="text"
                name="address"
                id="address"
                placeholder="Enter Address"
              />
            </div>
          </form>
          <div className="button">
            <button
              type="button"
              className="btn"
              id="submit"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              SUBMIT
            </button>
          </div>
        </div>
        <RangeTable reload={reload} />
      </div>
    </div>
  );
}

export default RangeEntry;
